"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssistantAppsApiService = void 0;
const baseApiService_1 = require("./baseApiService");
const account_controller_1 = require("./controller/account.controller");
const app_controller_1 = require("./controller/app.controller");
const appNotice_controller_1 = require("./controller/appNotice.controller");
const appReview_controller_1 = require("./controller/appReview.controller");
const badge_controller_1 = require("./controller/badge.controller");
const cache_controller_1 = require("./controller/cache.controller");
const contact_controller_1 = require("./controller/contact.controller");
const dashboard_controller_1 = require("./controller/dashboard.controller");
const donation_controller_1 = require("./controller/donation.controller");
const feedbackForm_controller_1 = require("./controller/feedbackForm.controller");
const feedbackFormAnswer_controller_1 = require("./controller/feedbackFormAnswer.controller");
const feedbackFormQuestion_controller_1 = require("./controller/feedbackFormQuestion.controller");
const language_controller_1 = require("./controller/language.controller");
const licence_controller_1 = require("./controller/licence.controller");
const oauth_controller_1 = require("./controller/oauth.controller");
const patreon_controller_1 = require("./controller/patreon.controller");
const permission_controller_1 = require("./controller/permission.controller");
const quickAction_controller_1 = require("./controller/quickAction.controller");
const steam_controller_1 = require("./controller/steam.controller");
const teamMember_controller_1 = require("./controller/teamMember.controller");
const translationImage_controller_1 = require("./controller/translationImage.controller");
const translationKey_controller_1 = require("./controller/translationKey.controller");
const translationReport_controller_1 = require("./controller/translationReport.controller");
const translationStat_controller_1 = require("./controller/translationStat.controller");
const user_controller_1 = require("./controller/user.controller");
const userActivity_controller_1 = require("./controller/userActivity.controller");
const version_controller_1 = require("./controller/version.controller");
const headerHelper_1 = require("../../helper/headerHelper");
const translation_controller_1 = require("./controller/translation.controller");
class AssistantAppsApiService extends baseApiService_1.BaseApiService {
    constructor(state) {
        var _a, _b;
        const apiUrl = (_a = state === null || state === void 0 ? void 0 : state.url) !== null && _a !== void 0 ? _a : 'https://api.assistantapps.com';
        super(apiUrl);
        this._state = {
            url: '',
            authToken: '',
        };
        this.addAccessTokenToHeaders = () => (0, headerHelper_1.addAccessTokenToHeaders)({ authToken: this._state.authToken });
        this.formDataWithAccessTokenHeaders = () => (0, headerHelper_1.formDataWithAccessTokenHeaders)({ authToken: this._state.authToken });
        this.account = (0, account_controller_1.accountController)(this);
        this.app = (0, app_controller_1.appController)(this);
        this.appNotice = (0, appNotice_controller_1.appNoticeController)(this);
        this.appReview = (0, appReview_controller_1.appReviewController)(this);
        this.badge = (0, badge_controller_1.badgeController)(this);
        this.cache = (0, cache_controller_1.cacheController)(this);
        this.contact = (0, contact_controller_1.contactController)(this);
        this.dashboard = (0, dashboard_controller_1.dashboardController)(this);
        this.donation = (0, donation_controller_1.donationController)(this);
        this.language = (0, language_controller_1.languageController)(this);
        this.licence = (0, licence_controller_1.licenceController)(this);
        this.feedbackForm = (0, feedbackForm_controller_1.feedbackFormController)(this);
        this.feedbackFormAnswer = (0, feedbackFormAnswer_controller_1.feedbackFormAnswerController)(this);
        this.feedbackFormQuestion = (0, feedbackFormQuestion_controller_1.feedbackFormQuestionController)(this);
        this.oAuth = (0, oauth_controller_1.oAuthController)(this);
        this.patreon = (0, patreon_controller_1.patreonController)(this);
        this.permission = (0, permission_controller_1.permissionController)(this);
        this.quickAction = (0, quickAction_controller_1.quickActionController)(this);
        this.steam = (0, steam_controller_1.steamController)(this);
        this.teamMember = (0, teamMember_controller_1.teamMemberController)(this);
        this.translation = (0, translation_controller_1.translationController)(this);
        this.translationImage = (0, translationImage_controller_1.translationImageController)(this);
        this.translationKey = (0, translationKey_controller_1.translationKeyController)(this);
        this.translationReport = (0, translationReport_controller_1.translationReportController)(this);
        this.translationStat = (0, translationStat_controller_1.translationStatController)(this);
        this.user = (0, user_controller_1.userController)(this);
        this.userActivity = (0, userActivity_controller_1.userActivityController)(this);
        this.version = (0, version_controller_1.versionController)(this);
        this._state.url = apiUrl;
        this._state.authToken = (_b = state === null || state === void 0 ? void 0 : state.authToken) !== null && _b !== void 0 ? _b : '';
    }
}
exports.AssistantAppsApiService = AssistantAppsApiService;
